import Grid from '@mui/material/Grid';
import Link from 'next/link';
import type { ReactElement } from 'react';
import getErrorDisplayStyles from './ErrorDisplayComponent.style';
import KariusLogo from '../assets/images/svg/KariusLogoWidget'; // todo use another pr's logo when header is merged

export interface ErrorHandlerI {
  errorCode: number;
  errorName: string;
  errorDescriptionFragment: ReactElement;
  shouldDisplayLogoDiv: boolean;
}

export default function ErrorDisplayComponent({
  errorCode,
  errorName,
  errorDescriptionFragment,
  shouldDisplayLogoDiv,
}: ErrorHandlerI) {
  const [CircleDiv, TextContainer, ErrorCode, ErrorName, ErrorDescription, LogoDiv, LogoLink] =
    getErrorDisplayStyles(shouldDisplayLogoDiv);

  return (
    <Grid
      container
      data-test='ErrorDisplayComponent'
      direction='row'
      justifyContent='center'
      alignItems='center'
      style={{ minHeight: '70vh' }}
    >
      <CircleDiv />
      <TextContainer>
        <ErrorCode>{errorCode}</ErrorCode>
        <ErrorName>{errorName}</ErrorName>
        <ErrorDescription>{errorDescriptionFragment}</ErrorDescription>
        {shouldDisplayLogoDiv ? (
          <>
            <LogoDiv>
              <KariusLogo style={{ width: 139 }} />
            </LogoDiv>
            <LogoLink>
              <Link href='/'>Go to kariusdx.com</Link>
            </LogoLink>
          </>
        ) : null}
      </TextContainer>
    </Grid>
  );
}
